export default {
  language: "繁体中文",
  nav: {
    home: "首頁",
    dealer: "經銷商",
    help: "幫助&反饋",
    subscription: "訂閱",
    couponCenter: "領券中心"
  },
  userMenu: {
    login: "登錄",
    profile: "個人信息",
    subscription: "訂閱",
    promotion: "我的推廣",
    help: "幫助&反饋",
    order: "訂單記錄",
    wallet: "我的錢包",
    coupons: "我的優惠券",
    changeLang: "語言切換",
    logout: "退出登錄"
  },
  footer: {
    aboutUsTitle: "關於我們",
    aboutUs: "關於我們",
    contactUs: "聯繫我們",
    business: "商務對接",
    legalTitle: "法律",
    terms: "條款 & 條件",
    privacy: "隱私政策",
    refund: "退款政策",
    regionTitle: "國家/地區",
    regionChina: "中國",
    language: "語言",
    langZhCN: "中文（簡體）",
    langEn: "English",
    serviceTitle: "客戶服務",
    helpSupport: "幫助 & 支持",
    onlineService: "在線客服"
  },
  header: {
    helpTitle: "請問有什麼需要幫助?",
    searchPlaceholder: "請輸入關鍵字進行搜索",
    recommendTitle: "為您推薦",
    changeAnother: "換一換",
    subscriptionTitle: "訂閱服務",
    userCenterTitle: "個人資訊",
    myAccountTitle: "我的賬戶",
    myPromotionTitle: "我的推廣",
    myWalletTitle: "我的錢包",
    myCouponsTitle: "我的優惠券",
    orderTitle: "訂單記錄",
    couponCenterTitle: "領券中心",
    registerCouponTitle: "新人優惠券",
    '立即與OTTBUS合作吧！':'立即與OTTBUS合作吧！',
    '加入我們，開啓賺錢的旅程！':'加入我們，開啓賺錢的旅程！',
    '馬上開始':'馬上開始',
  },
  login: {
    welcomeTitle: "你好!",
    welcomeSubtitle: "享受美妙的體驗!",
    cardTitle: "登錄或註冊",
    emailPlaceholder: "郵箱",
    passwordPlaceholder: "密碼",
    useCodeLogin: "使用驗證碼登錄",
    codePlaceholder: "驗證碼",
    sending: "發送中...",
    sendCode: "發送驗證碼",
    sent: "已發送",
    passwordLogin: "密碼登錄",
    instruction: "請使用您註冊 OTTBUS 時使用的電子郵件登錄",
    continue: "繼續",
    or: "或",
    termsPrefix: "繼續，即表示您同意我們的",
    termsLinkText: "條款 & 條件",
    privacyPrefix: " 並確認您已閱讀我們的 ",
    privacyLinkText: "隱私政策",
    discountRate: "할인 율최대80%",
    discountDesc: "구독 부담 절반으로, 즐거움 배로!"
  },
  auth: {
    confirmLogout: "確定退出系統嗎？",
    confirmTitle: "提示",
    ok: "確定",
    cancel: "取消",
    invalidEmail: "請輸入正確的郵箱地址",
    passwordRequired: "密碼不能為空",
    loginSuccess: "登錄成功",
    codeRequired: "請輸入驗證碼",
    passwordLength: "用戶密碼長度必須介於 6 和 20 之間",
    passwordMismatch: "兩次密碼輸入不一致",
    registerLoginSuccess: "註冊並登錄成功",
    unsupportedPasswordLogin: "該賬號不支持密碼登錄，請使用驗證碼登錄",
    loginFailedUseCode: "登錄失敗，請使用驗證碼登錄",
    loginFailedRetry: "登錄失敗，請重試",
    codeSendFailed: "驗證碼發送失敗，請稍後重試"
  },
  setPassword: {
    title: "設置密碼",
    description: "為了提升賬號安全，同時防止因無法獲取驗證碼導致無法登入，請設置登入密碼。",
    passwordPlaceholder: "請輸入密碼",
    confirmPasswordPlaceholder: "請再次輸入密碼",
    requirementsTitle: "您的密碼必須包含:",
    requirementLength: "8到20個字元",
    requirementFormat: "字母和數字",
    requirementMatch: "您輸入的兩次密碼相同",
    continue: "繼續",
    skip: "跳過",
    success: "密碼設置成功",
    failure: "密碼設置失敗，請重試"
  },
  helpPage: {
    feedbackCardTitle: "提交反饋",
    feedbackCardSubtitle: "填寫您要反饋的問題",
    serviceCardTitle: "在線客服",
    serviceCardSubtitle: "24小時一站式服務",
    dialogTitle: "問題反饋",
    formProblemTitle: "反饋問題",
    formProblemPlaceholder: "請描述要反饋的問題",
    formContactTitle: "聯繫方式",
    formContactPlaceholder: "請輸入聯繫方式",
    submit: "提交",
    problemRequired: "描述問題不能為空",
    contactRequired: "聯繫方式不能為空",
    confirmSubmit: "確定提交問題反饋嗎？",
    confirmTitle: "提示",
    ok: "確定",
    cancel: "取消",
    submitSuccess: "提交成功！",
    '聯繫專屬客服以獲取高效支持': '聯繫專屬客服以獲取高效支持',
    // 新增帮助中心多语言
    helpCenter: "幫助中心",
    searchPlaceholder: "搜索幫助中心...",
    hotArticles: "熱門問題",
    frequentlyReadArticles: "常見問題",
    browseAllCategories: "瀏覽所有分類",
    categories: "分類",
    searchResults: "搜索結果",
    clearSearch: "清除搜索",
    noResults: "未找到相關內容",
    noArticles: "暫無文章",
    loading: "加載中...",
    loadMore: "加載更多",
    back: "返回",
    goToWebsite: "前往網站",
    howCanWeHelp: "我們能幫您什麼？",
    articlesOn: "文章分類",
    viewCount: "閱讀量",
    defaultCategoryDesc: "查看相關幫助文章"
  },
  helpDetail: {
    title: "幫助中心",
    updated: " 更新",
    relatedArticles: "相關文章"
  },
  userProfile: {
    title: "個人資訊",
    nickname: "暱稱",
    email: "郵箱",
    password: "密碼",
    editNickname: "修改暱稱",
    nicknamePlaceholder: "請輸入暱稱",
    submit: "提交",
    editPassword: "修改密碼",
    codeSent: "驗證碼已發送至{email}，請注意查收：",
    codePlaceholder: "請輸入驗證碼",
    sendCode: "獲取驗證碼",
    resendIn: "{time}S後獲取",
    newPasswordPlaceholder: "請設置密碼",
    confirmPasswordPlaceholder: "請再次確認密碼",
    editEmail: "修改郵箱",
    newEmailPlaceholder: "請輸入新郵箱",
    updateSuccess: "修改成功",
    passwordRequired: "密碼不能為空",
    passwordMismatch: "兩次密碼輸入不一致",
    nicknameRequired: "請輸入暱稱！",
    uploadFailed: "上傳文件失敗，請重試",
    uploading: "正在上傳圖片，請稍候..."
  },
  subscriptionPage: {
    title: "訂閱服務",
    tagRecharging: "充值中",
    tagToRedeem: "待兌換",
    tagSubscribed: "訂閱中",
    productLabel: "產品：",
    codeLabel: "兌換碼：",
    startTime: "開始時間：",
    endTime: "結束時間：",
    remark: "備註：",
    renewService: "續訂服務",
    goRedeem: "前往兌換",
    newTicket: "新建工單",
    faq: "問題解答",
    emptyText: "暫無訂閱內容",
    goSubscribe: "去訂閱",
    dialogNewTicketTitle: "新建工單",
    emailLabel: "郵箱",
    emailPlaceholder: "請輸入你的郵箱",
    questionTypeLabel: "問題類別",
    selectPlaceholder: "請選擇",
    questionDetailLabel: "問題詳情",
    submit: "提交",
    redeemSuccessTitle: "兌換成功",
    accountLabel: "賬號：",
    passwordLabel: "密碼：",
    rechargeAccount: "充值賬號：",
    copySuccess: "兌換碼複製成功！",
    copyFail: "複製失敗",
    confirmRedeem: "確定兌換嗎？",
    emailRequired: "請輸入你的郵箱！",
    questionTypeRequired: "請選擇問題類別！",
    detailRequired: "請填寫問題詳情！",
    submitSuccess: "提交成功！",
    '订单编号': '訂單編號',
    '联系客服': '聯系客服',
    expand: '展開',
    collapse: '收起',
    adminRemark: '備註',
    captchaLabel: '驗證碼',
    fetching: '獲取中...',
    clickToGet: '接收驗證碼',
    viewDetail: '獲取驗證碼詳情',
    noCaptchaEmail: '無法獲取驗證碼，請重新發送或等待1分鐘後再獲取'
  },
  orderPage: {
    title: "訂單記錄",
    all: "全部",
    unpaid: "未支付",
    paid: "已支付",
    completed: "已完成",
    refunded: "已退款",
    thName: "訂單名稱",
    thDuration: "訂閱時間",
    thAmount: "支付金額",
    thStart: "生效時間",
    thStatus: "訂單狀態",
    idPrefix: "ID:",
    emptyText: "暫無內容",
    status: {
      0: "未支付",
      1: "已支付",
      2: "已完成",
      9: "已退款",
      "-1": "已取消"
    },
    duration: {
      1: "1個月",
      3: "3個月",
      6: "6個月",
      12: "12個月"
    },
    '订单编号': '訂單編號',
    '操作': '操作',
    '退款': '退款',
    '去支付': '去支付',
    cancelOrder: '取消訂單',
    cancelOrderConfirm: '確定要取消該訂單嗎？',
    cancelOrderSuccess: '訂單已取消',
    cancelOrderFailed: '取消失敗，請稍後重試',
    cancelOrderForbiddenPaid: '訂單已存在成功支付記錄，無法取消',
    '退款申请': '退款申請',
    '退款理由': '退款理由',
    '请填写退款理由': '請填寫退款理由',
    '订单不存在': '訂單不存在',
    '订单不支持退款': '訂單不支持退款',
    '申请失败': '申請失敗',
    '操作成功': '操作成功',
    refundStatus: {
      1: '退款申請中',
      2: '待確認退款',
      3: '後台已拒絕',
      4: '退款成功',
      5: '已拒絕退款'
    },
    // 退款确认相关
    confirmRefund: '確認退款',
    refundConfirmTitle: '退款確認',
    refundAmountLabel: '退款金額',
    refundConfirmTip: '確認退款後，金額將退回您的錢包',
    agreeRefund: '同意退款',
    rejectRefund: '拒絕退款',
    refundSuccess: '退款成功，金額已退回錢包',
    refundRejected: '已拒絕退款',
    operationFailed: '操作失敗',
    refundDisabledTip: '退款功能未開啟，請聯繫客服處理',
    checkRefundFailed: '檢查退款權限失敗',
    refundContactService: '如需退款，請聯繫客服',
    adminRemark: '備註',
    refundApplySuccess: '退款申請已提交',
    refundRemarkLabel: '審核結果'
  }
  ,
  indexPage: {
    titlePart1: "我們",
    titlePart2: "有什麼",
    menuRecommend: "全部",
    sharingUsersSuffix: "位用戶正在共享",
    buyNow: "前往購買",
    more: "更多",
    foldUp: "收起",
    noContent: "暫無內容",
    advantagesTitlePart1: "我們的",
    advantagesTitlePart2: "優勢有哪些？",
    consultNow: "立即諮詢",
    feedbackTitle: "出色的用戶反饋",
    bulletCheap: "價格低廉，全家桶更划算",
    bulletDesktopOnly: "僅支持 Windows 與 macOS 桌面端",
    coupon: {
      headerTitle: "新用戶專享福利",
      headerSubtitle: "歡迎加入，這是給您的見面禮",
      discountConditionPrefix: "滿",
      discountConditionSuffix: "可用",
      directDiscount: "無門檻直接抵扣",
      validityLabel: "有效期至",
      cardNote: "首次下單即可使用",
      rule1: "新用戶註冊即可領取",
      rule2: "全平台通用，特殊商品除外",
      rule3: "領取後12個月內有效",
      receiveBtn: "立即領取",
      successTitle: "領取成功！",
      successMessage: "優惠券已放入您的賬戶，快去使用吧！",
      successOk: "好的"
    },
    dialog: {
      buyTitle: "產品購買",
      type: "類型",
      direct: "直充",
      shared: "共享",
      duration: "時長",
      couponCode: "有優惠碼嗎？",
      couponPlaceholder: "請輸入優惠碼",
      note: "溫馨提示：由於虛擬產品的特性，售出24小時後暫不支持退款，如遇產品問題，我們將盡快修復，並補償您的使用時長，以確保您的良好體驗",
      submit: "提交",
      accountTitle: "賬號密碼",
      accountLabel: "充值賬號",
      passwordLabel: "密碼",
      backupCodeLabel: "備用碼",
      payTitle: "選擇支付方式",
      payMethod: "OTTBUS 不會儲存您的銀行卡資訊。所有交易均由外部支付提供商進行保護、處理和授權。(如遇支付跳轉失敗，請更换設備重新嘗試)",
      confirm: "確定",
      save: "節約",
      orgPrice: "原價：",
      '请填写充值账号': '請填寫充值帳號',
      '请填写充值账号密码': '請填寫充值帳號密碼',
      '请填写充值账号备用码': '請填寫充值帳號備用碼',
      '节约': '節約',
      '注意事项': '注意事項',
      googleBakCode: '如何設定 Google 備用驗證碼',
      noStock: '暫時缺貨',
      '备注': '备注',
      '请填写充值账号备注': '请输入UP博主名称和对应的会员类别',
      '数量': '数量',
      '请输入您要充值的账户(GoogleMail)': '请输入您要充值的账户(Google Mail)',
      '购买须知': '购买须知'
    },
    validate: {
      fillAccount: "請填寫充值賬號",
      fillPassword: "請填寫充值賬號密碼",
      choosePayMethod: "請選擇支付方式"
    },
    adv: {
      payNowTitle: "立即交付",
      payNowDesc: "付款後實时交付-無需等待",
      customerServiceTitle: "客服協助",
      customerServiceDesc: "OTTBUS提供7x24小時線上客服服務",
      globalPayTitle: "全球支付",
      globalPayDesc: "保障來自100多個國家的付款安全",
      shareTitle: "訂閱分享",
      shareDesc: "經濟實惠的高級訂閱共亯：按地點優先匹配",
      refundTitle: "快速退款",
      refundDesc: "24小時無條件退款",
      premiumTitle: "高級中心",
      premiumDesc: "在OTTBUS上，體驗“一站式”高級訂閱",
    },
    type: {
      '视频': '視頻',
      '音乐': '音樂',
      'AI': 'AI',
      '办公': '辦公',
      '学习': '學習',
      '其他': '其他'
    },
    month: "月",
    months: " 個月",
    permanent: "永久",
    pay: {
      creditcardKR: "South Korea Credit Card",
      ebankingKR: "South Korea Internet Banking",
      kakaopay: "KakaoPay",
      payco: "PAYCO",
      ssgpay: "SSG Pay",
      samsungpay: "Samsung Pay",
      alipayHK: "大陸支付寶",
      alipayWalletHK: "香港支付寶",
      alipayTW: "大陸支付寶",
      jkoTW: "街口支付",
      useWallet: "使用錢包餘額支付",
      walletBalance: "錢包餘額",
      walletDeduct: "錢包抵扣",
      walletDeductInput: "錢包抵扣金額",
      walletDeductMaxTip: "最多可抵扣",
      remainingToPay: "剩餘需支付",
      enterPayPassword: "請輸入6位數字支付密碼",
      noPasswordTip: "您尚未設置支付密碼",
      goSetPassword: "去設置",
      paySuccess: "支付成功",
      payFailed: "支付失敗，請重試",
      paymentUrlError: "支付鏈接獲取失敗，請重試",
      insufficientBalance: "錢包餘額不足",
      walletAlreadyPaid: "已使用錢包支付",
      walletAlreadyUsed: "此訂單已使用錢包支付",
      walletPendingTip: "已設置錢包抵扣，支付成功後才會扣除",
      regionAutoDetectFallback: "目前無法識別您的所在地區，已展示韓國、香港與台灣支付方式，請手動選擇。",
      antomCashierTitle: "正在前往支付頁",
      antomCashierDescription: "系統會在此頁直接渲染對應支付組件，若未正常顯示，請點擊下方按鈕重新拉起。",
      antomCashierLoading: "正在加載支付組件，請稍候...",
      antomCashierReady: "支付組件已就緒，請在下方完成付款。",
      antomCashierOpenFailed: "支付頁打開失敗，請重新嘗試。",
      antomCashierMissingSession: "支付會話已失效，請返回商品頁重新下單。",
      antomCashierRetry: "重新打開支付",
      antomCashierBackHome: "返回首頁",
      antomCashierOrderCode: "訂單號",
      antomCashierAmount: "支付金額",
      antomCashierSuccessHint: "支付已提交，請等待訂單狀態更新。",
      antomCashierCancelHint: "您已取消支付，可重新發起。",
      antomCashierEventPrefix: "支付組件狀態",
      antomResultTitle: "支付結果確認中",
      antomResultDescription: "支付完成後，系統會在此頁同步查詢訂單狀態。",
      antomResultLoading: "正在查詢最新訂單狀態...",
      antomResultPending: "支付結果同步中，請稍候。",
      antomResultPaid: "訂單已支付。",
      antomResultCompleted: "訂單已完成。",
      antomResultRefunded: "訂單已退款。",
      antomResultUnknown: "暫未識別到最終狀態，請稍後到訂單中心查看。",
      antomResultMissingOrder: "缺少支付訂單號，無法查詢結果。",
      antomResultNoLogin: "當前未登錄，無法自動查詢訂單狀態，請登錄後前往訂單中心查看。",
      antomResultQueryFailed: "訂單狀態查詢失敗，請稍後重試。",
      antomResultOrderStatus: "訂單狀態",
      antomResultRetry: "重新查詢",
      antomResultViewOrders: "查看訂單"
    }
  }
  ,
  promotionPage: {
    myPromotion: "我的推廣",
    myWallet: "我的錢包",
    code: "推廣連結：",
    promotionRecords: "推廣記錄",
    totalCommission: "總計傭金：",
    thOrderName: "訂單名稱",
    thDuration: "訂閱時間",
    thPaid: "支付金額",
    thEffective: "生效時間",
    thBuyer: "訂單人",
    thCommission: "傭金",
    thStatus: "狀態",
    settled: "已結算",
    pending: "待結算",
    unpaid: "待支付",
    refunded: "已退款",
    goodsDetail: "推廣商品",
    thPrice: "售價",
    commissionRate: "分佣比例",
    commissionAmount: "分佣金額",
    remark: "備註",
    withdrawable: "可提現:",
    withdraw: "提現",
    withdrawalRecords: "提現記錄",
    totalWithdrawal: "總計提現：",
    thWithdrawAmount: "提現金額",
    thBank: "到賬銀行卡",
    thCardholder: "銀行卡姓名",
    thWithdrawTime: "提現時間",
    thWithdrawStatus: "提現結果",
    withdrawAmount: "提現金額",
    bankCard: "到賬銀行卡號",
    cardholder: "持卡人姓名",
    placeholderWithdrawAmount: "請輸入提現金額",
    placeholderBankCard: "請輸入到賬銀行卡號",
    placeholderCardholder: "請輸入持卡人姓名",
    '链接复制成功': '連結複製成功',
    adAgentNoWithdraw: "廣告代理無法提現",
    adAgentNotice: "您是廣告代理用戶，無法進行提現操作，佣金也不會到賬。如有疑問請聯繫客服。",
    // 银行卡管理
    myBankCards: "我的銀行卡",
    addBankCard: "添加銀行卡",
    editBankCard: "編輯銀行卡",
    noBankCards: "暫無銀行卡，請先添加",
    selectBankCard: "選擇銀行卡",
    manualInput: "手動輸入",
    bankName: "銀行名稱",
    cardNumber: "銀行卡號",
    cardHolder: "持卡人姓名",
    placeholderBankName: "請輸入銀行名稱",
    placeholderCardNumber: "請輸入銀行卡號",
    placeholderCardHolder: "請輸入持卡人姓名",
    setAsDefault: "設為默認銀行卡",
    defaultCard: "默認",
    save: "保存",
    saveSuccess: "保存成功",
    saveFailed: "保存失敗",
    deleteSuccess: "刪除成功",
    confirmDeleteCard: "確定要刪除這張銀行卡嗎？",
    confirmWithdraw: "確定要提現嗎？",
    withdrawSuccess: "提現申請已提交",
    withdrawAmountExceeded: "提現金額不能大於可提現金額",
    // 提现方式
    myWithdrawAccounts: "我的提現賬戶",
    addWithdrawAccount: "添加提現方式",
    editWithdrawAccount: "編輯提現方式",
    noWithdrawAccounts: "暫無提現賬戶，請先添加",
    withdrawType: "提現方式",
    selectWithdrawType: "請選擇提現方式",
    usdtAddress: "USDT錢包地址 (TRC20)",
    placeholderUsdtAddress: "請輸入USDT錢包地址"
  }
  ,
  hello: {
    guideLine1: "有關如何配置/自訂此專案的指南與範例，",
    guideCheckOut: "請查看",
    vueCliDocs: "vue-cli 文件",
    installedTitle: "已安裝的 CLI 外掛",
    plugins: { babel: "babel", eslint: "eslint" },
    essentialTitle: "重要連結",
    links: {
      coreDocs: "核心文件",
      forum: "論壇",
      communityChat: "社群聊天",
      twitter: "Twitter",
      news: "新聞"
    },
    ecosystemTitle: "生態系",
    ecosystem: {
      router: "vue-router",
      vuex: "vuex",
      devtools: "vue-devtools",
      loader: "vue-loader",
      awesome: "awesome-vue"
    }
  }
  ,
  dealerPage: {
    adv1Title: "專業團隊",
    adv1Desc: "專業團隊服務，加入 OTTBUS",
    adv2Title: "分享賺傭",
    adv2Desc: "分享連結，用戶購買，你得傭金",
    adv3Title: "續訂得傭",
    adv3Desc: "用戶續訂，額外獲得傭金",
    adv4Title: "24小時服務",
    adv4Desc: "一對一專業對接服務",
    advantagesTitle: "選我們的優勢有哪些？",
    advantagesSubtitle: "輕鬆解決賺取傭金的問題",
    startNow: "立即開始",
    howToJoinTitle: "如何加入我們？",
    howToJoinSubtitle: "輕鬆解決賺取傭金的問題",
    join1Title: "註冊賬號",
    join1Desc: "首先進行賬號註冊，註冊成功後，請進入經銷商板塊",
    join2Title: "申請加盟",
    join2Desc: "在經銷商板塊進行加盟申請，通過後即可進行邀請",
    join3Title: "分享邀請",
    join3Desc: "分享邀請連結，其他用戶經連結購買即可獲得傭金",
    shareSlogan: "加入我們，分享您的連結開啟賺錢之旅！",
    startEarning: "立即開始賺錢",
    dialogTitle: "加入我們",
    detailSubtitle: "OTTBUS 期待您的加入，請填寫表單信息，以更方便您的加入。",
    formRealName: "真實姓名",
    placeholderRealName: "請輸入您的姓名",
    formPhone: "手機號碼",
    placeholderPhone: "請輸入聯繫電話",
    formCurrency: "賬戶幣種",
    formPromotionWhere: "您將在那裡推廣 OTTBUS?",
    placeholderLink: "請輸入連結",
    formLanguageQuestion: "您用什麼語言進行社交媒體促銷？",
    selectPlaceholder: "請選擇",
    formContactHow: "我們可以通過什麼方式聯繫您？",
    placeholderContactInfo: "您的聯繫方式",
    formPaymentWay: "您想使用什麼付款方式？",
    formInviteCode: "如有邀請人，請填寫邀請碼",
    placeholderInviteCode: "請輸入邀請碼",
    close: "關閉",
    submit: "提交",
    validate: {
      fillRealName: "請填寫真實姓名",
      fillPhone: "請填寫手機號",
      chooseCurrency: "請選擇賬戶幣種",
      choosePromotionChannels: "請選擇推廣途徑",
      promotionLinkRequired: "推廣途徑的推廣連結不能為空",
      chooseLanguage: "請選擇社交語言",
      chooseContactType: "請選擇聯繫類型",
      fillContactInfo: "請輸入聯繫方式",
      choosePaymentWay: "請選擇付款方式"
    },
    confirmSubmit: "確定提交嗎？",
    submitSuccess: "提交成功！",
    '开启您的推广之旅': '開啟您的推廣之旅'
  },
  text: {
    '已经领取过': '已經領取過',
    '商品库存不足': '庫存不足',
    '优惠码无效': '優惠碼無效',
    '请填写备注': '请填写备注',
    couponNotFound: '優惠碼不存在或已過期',
    couponUsed: '該優惠碼已被使用',
    couponExpired: '該優惠碼已過期',
    stockInsufficient: '已達到最大可購買數量'
  },
  wallet: {
    myWallet: "我的錢包",
    balance: "錢包餘額",
    balanceTip: "僅限平台消費，不可提現",
    setPassword: "設置支付密碼",
    changePassword: "修改支付密碼",
    records: "交易記錄",
    all: "全部",
    income: "收入",
    expense: "支出",
    refundIncome: "退款入賬",
    paymentExpense: "消費支出",
    noRecords: "暫無交易記錄",
    loading: "加載中...",
    loadMore: "加載更多",
    oldPassword: "原密碼",
    newPassword: "新密碼",
    password: "支付密碼",
    confirmPassword: "確認密碼",
    enterOldPassword: "請輸入原密碼",
    enterPassword: "請輸入6位數字密碼",
    enterConfirmPassword: "請再次輸入密碼",
    passwordTip: "支付密碼為6位數字",
    confirm: "確認",
    passwordLengthError: "密碼必須為6位數字",
    passwordFormatError: "密碼必須為6位數字",
    passwordNotMatch: "兩次輸入的密碼不一致",
    setSuccess: "設置成功",
    operationFailed: "操作失敗，請重試"
  },
  couponHall: {
    pageTitle: "可領取優惠券",
    pageSubtitle: "在這裡集中查看可領取活動券，確認數量、時效與適用商品後即可登入領取。",
    loginTip: "未登入用戶也可以先瀏覽活動內容，登入後即可把可領取優惠券加入賬戶。",
    allGoods: "全部商品",
    receiveNow: "立即領取",
    loginToReceive: "登入後領取",
    viewMyCoupons: "查看我的優惠券",
    receiveSuccess: "優惠券領取成功",
    receiveFailed: "優惠券領取失敗",
    statusAvailable: "可領取",
    statusUpcoming: "即將開始",
    statusEnded: "已結束",
    statusSoldOut: "已領完",
    statusLimitReached: "已達個人上限",
    conditionLabel: "使用條件",
    validityLabel: "有效期",
    windowLabel: "領取時間",
    quotaLabel: "數量資訊",
    goodsLabel: "適用商品",
    unlimited: "不限",
    remaining: "剩餘",
    perUserLimit: "每人限領",
    emptyTitle: "目前沒有可領取的優惠券",
    emptySubtitle: "可能是活動尚未上架或已被管理端隱藏，稍後再來看看，或先去逛逛商品吧。",
    goShopping: "去購物"
  },
  coupon: {
    myCoupons: "我的優惠券",
    couponTip: "查看和管理您的優惠券",
    claimEntrance: "領取新人券",
    claimPageTitle: "新人優惠券領取",
    claimPageSubtitle: "完成領取後可直接在下單時使用",
    claimNow: "立即領取",
    loginToClaim: "登入後領取",
    loginRequiredTip: "未登入用戶可先查看優惠券資訊，登入後即可領取到您的賬戶。",
    notClaimedYet: "尚未領取",
    alreadyClaimed: "已領取",
    previewMode: "僅供查看",
    claimSuccess: "領取成功",
    claimFailed: "領取失敗，請稍後再試",
    viewMyCoupons: "查看我的優惠券",
    all: "全部",
    unused: "未使用",
    used: "已使用",
    expired: "已過期",
    conditionLabel: "使用條件",
    statusLabel: "當前狀態",
    couponCodeLabel: "優惠券代碼",
    minSpend: "滿",
    noThreshold: "無使用門檻",
    validForDays: "領取後 {days} 天內有效",
    directDiscount: "直接折扣",
    validUntil: "有效期至",
    available: "可使用",
    canUse: "可用",
    noCoupons: "暫無優惠券",
    noCouponsTip: "暫時沒有優惠券，去購物獲取更多優惠吧",
    goShopping: "去購物"
  },
  promotion: {
    invitedUsers: "邀請用戶",
    userCount: "已邀請用戶數",
    totalOrders: "總訂單數",
    pendingCommission: "待結算佣金",
    settledCommission: "已結算佣金",
    viewOrders: "查看訂單",
    hideOrders: "收起訂單",
    noUsers: "暫無邀請用戶",
    registerTime: "註冊時間",
    orderStatus: "訂單狀態",
    statusPending: "待支付",
    statusPaid: "已支付",
    statusCompleted: "已完成",
    statusRefunded: "已退款",
    statusUnknown: "未知"
  },
  orderDetail: {
    relatedProducts: "相關推薦",
    faq: "常見問題",
    viewMoreFaq: "查看更多問題"
  },
  detailPage: {
    selectSku: "選擇SKU",
    sold: "已售",
    subtotal: "小計",
    couponDiscount: "促銷碼&優惠券",
    selectCoupon: "請選擇優惠券",
    total: "合計",
    hasCoupon: "有促銷碼嗎？",
    hasCouponAvailable: "您有可用的優惠券",
    noCoupon: "不使用優惠券",
    buyNow: "立即購買",
    outOfStock: "庫存不足",
    howToUse: "如何使用？",
    viewUsageGuide: "查看使用指南",
    noUsageGuide: "暫無對應的使用指南",
    faq: "常見問題",
    relatedProducts: "相關推薦",
    invalidCoupon: "無效優惠碼",
    invalidCouponConfirmTitle: "優惠券無效",
    invalidCouponConfirmMessage: "您輸入的優惠券無效，是否繼續購買？",
    continuePurchase: "繼續購買",
    selectDiscount: "選擇優惠",
    pleaseSelect: "請選擇",
    promoCodePlaceholder: "輸入促銷碼",
    apply: "使用",
    quantity: "數量",
    unavailableTitle: "商品暫不可用",
    unavailableMessage: "目前此商品在您所在地區暫不可查看或購買，請返回首頁選擇其他商品。",
    unavailableNoSpec: "目前此商品暫無可售規格，請稍後再試。",
    backHome: "返回首頁"
  }
}
